import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Form, Input, message, Modal } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

function ApplyTry({ isModalOpen, setIsModalOpen }) {
  const { t, i18n } = useTranslation();
  const { form } = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const handleOk = (values) => {
    setConfirmLoading(true);
    fetch('/prod-api/website/apply-try', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(values)
    }).then(res => {
      if (res.status === 200) {
        messageApi.open({
          type: 'success',
          content: t('contact.submitSuccess'),
          duration: 5
        });
        setIsModalOpen(false);
      }
      return res.json();
    }).then(data => {
      console.log(data);
      setConfirmLoading(false);
    }).catch(err => {
      messageApi.open({
        type: 'error',
        content: t('contact.systemError'),
        duration: 5
      });
      setConfirmLoading(false);
      console.log(err);
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      {contextHolder}
      <Modal
        title={t('contact.applyTry')}
        open={isModalOpen}
        onCancel={handleCancel}
        okButtonProps={{ autoFocus: true, htmlType: 'submit', loading: confirmLoading }}
        destroyOnClose
        okText={t('contact.submit')}
        cancelText={t('contact.cancel')}
        modalRender={(dom) => (
          <Form
            layout="vertical"
            form={form}
            name="register"
            onFinish={values => handleOk(values)}
            style={{ maxWidth: 600 }}
            scrollToFirstError
            clearOnDestroy
          >
            {dom}
          </Form>
        )}
      >
        <Form.Item
          name="name"
          label={t('contact.name')}
          rules={[{ required: true, message: t('contact.validName'), whitespace: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="email"
          label={t('contact.email')}
          rules={[
            {
              type: 'email',
              message: t('contact.validEmailFormat')
            },
            {
              required: true,
              message: t('contact.validEmail')
            }
          ]}
          tooltip={{ title: t('contact.emailTips'), icon: <InfoCircleOutlined /> }}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="phone"
          label={t('contact.phone')}
          rules={[
            { required: true, message: t('contact.validPhone') },
            { pattern: /^1[3-9]\d{9}$/, message: t('contact.validPhoneFormat')}
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="companyName"
          label={t('contact.companyName')}
          rules={[{ required: true, message: t('contact.validCompanyName') }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="remark"
          label={t('contact.remark')}
        >
          <Input.TextArea showCount maxLength={200} />
        </Form.Item>
        <Alert message={t('contact.submitTips')} />
      </Modal>
    </div>
  );
}

export default ApplyTry;
